export function tab() {
  const tabBlocks = document.querySelectorAll(".c-tab");

  tabBlocks.forEach((tabBlock) => {
    const tabMenu = tabBlock.querySelectorAll(".c-tab__menuItem");
    const tabContent = tabBlock.querySelectorAll(".c-tab__contentItem");

    tabMenu.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        tabMenu.forEach((otherTab, otherIndex) => {
          const isActive = otherIndex === index;
          otherTab.classList.toggle("js-tab-active", isActive);
          otherTab.setAttribute("aria-selected", isActive ? "true" : "false");
          tabContent[otherIndex].style.display = isActive ? "block" : "none";
          tabContent[otherIndex].hidden = !isActive;
        });
      });
    });
  });
}
